import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "./api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si el correo existe, se enviaron instrucciones.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full border border-[#B2967D]/50 px-4 py-3 bg-white text-black placeholder:text-[#B2967D] focus:outline-none focus:border-[#7D5A44] transition-colors font-light";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#7D5A44] px-6 font-poppins">
      <div className="w-full max-w-md bg-white p-10">
        <h1 className="text-2xl font-bold text-black">Recuperar contraseña</h1>
        <p className="mt-2 text-sm font-light text-black/50">
          Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.
        </p>
        {sent ? (
          <div className="mt-8 border-l-2 border-[#7D5A44] pl-4 py-2 text-sm font-light text-black/70" data-testid="forgot-sent">
            Si el correo está registrado, recibirás un enlace de recuperación. Revisa tu bandeja de entrada.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
            <input
              data-testid="forgot-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="correo@iblvc.com"
              className={input}
              required
            />
            <button
              data-testid="forgot-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#7D5A44] text-white px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-black transition-colors duration-300 disabled:opacity-60"
            >
              {loading ? "Enviando..." : "Enviar instrucciones"}
            </button>
          </form>
        )}
        <div className="mt-6">
          <Link to="/admin/login" className="text-sm font-light text-[#B2967D] hover:text-black">
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
